import type {ExtractPropsWithoutRef} from '@/types';

import {Container} from '@/components/ResultListHeader/components/Container';
import {Controls} from '@/components/ResultListHeader/components/Controls';
import {DropdownGroup} from '@/components/ResultListHeader/components/DropdownGroup';
import {Subtitle} from '@/components/ResultListHeader/components/Subtitle';
import {Title} from '@/components/ResultListHeader/components/Title';
import {Titles} from '@/components/ResultListHeader/components/Titles';

type Props = Omit<ExtractPropsWithoutRef<typeof Container>, 'title'> & {
  title: React.ReactNode;
  subtitle?: string;
  filterControl?: React.ReactNode;
  regionSelect?: React.ReactNode;
  sortingControl: React.ReactNode;
};

export const ResultListHeader: React.FunctionComponent<Props> = ({
  title,
  subtitle,
  regionSelect,
  filterControl,
  sortingControl,
  ...restProps
}) => {
  return (
    <Container {...restProps}>
      <Titles>
        <Title>{title}</Title>
        {Boolean(subtitle) && <Subtitle>{subtitle}</Subtitle>}
      </Titles>
      <Controls>
        {filterControl}
        <DropdownGroup direction="row" justifyContent="space-between">
          {regionSelect}
          {sortingControl}
        </DropdownGroup>
      </Controls>
    </Container>
  );
};
